// extracted by mini-css-extract-plugin
export var avatar = "_oq-3";
export var avatarContainer = "_oq-2";
export var avatarSpacer = "_oq-5";
export var avatarSpacerContainer = "_oq-4";
export var avatarStackContainer = "_oq-1";
export var bubble = "_oq-0";
export var remainderBubble = "_oq-6";